import fileStatusEnum from '../../constants/fileStatus.enum';
import IState from '../models/IState';
import { createSelector } from "reselect";

const stateAllFiles = (state: IState) => state.file.fileList.files;

export const allFiles = createSelector(
    stateAllFiles,
    (files) => {
        if (files.FileList && files.FileList.length > 0)
            return files.FileList.map((file: any) => {
                return {
                    id: file.ID,
                    FileName: file.FileName,
                    Date: file.CreateDate,
                    Status: fileStatusEnum[file.Status],
                    isDelete: file.Status === 1 || file.Status === 2,
                    isDownload: file.Status !== 1 ? false : true,
                }
            })
        return [];
    }
)